
export const salaryConfigVI = {
    "salary-config": {
        "title": "Cấu hình bảng lương",
        "title-save": "Thêm cấu hình bảng lương",
        "title-edit": "Sửa cấu hình bảng lương",
        "title-view": "Chi tiết cấu hình bảng lương",
        "fields": {
            "main": "Chính",
            "extra": "Phụ",
            "day" : "Ngày",
            "name" : "Tên cấu hình bảng lương",
            "other-tables" : "Liên kết với bảng lương khác",
            "keyword" : "Từ khóa đại diện",
            "apply-department" : "Phòng ban áp dụng",
            "apply-position" : "Vị trí áp dụng",
            "salaryType" : "Bảng lương",
            "report" : "Bảng lương lên báo cáo",
            "employee-manage" : "Người quản lý",
            "employee-follow" : "Người theo dõi",
            "autoGenerated-checked" : "Tự động tạo bảng lương hàng tháng",
            "autoGenerated" : "Tự động tạo vào ngày",
            "columnName" : "Cột",
            "valueColumn" : "Giá trị cột",
            "titleColumn" : "Tiêu đề cột",
            "keyColumn" : "Từ khóa cột",
            "calculation" : "Cách tính (Công thức/Hằng số)",
            "rowValue" : "Giá trị của hàng tổng hợp khi tách dòng",
            "typeValue" : "Kiểu giá trị",
            "formatOption" : "Kiểu dữ liệu",
            "paycheck" : "Phiếu lương",
            "valueSynthetic" : "Giá trị tổng hợp",
            "describe" : "Mô tả",
            "report-value-yes" : "Có",
            "report-value-no" : "Không",
            "creatorDay" : "Ngày tạo",
            "employeeCreator" : "Người tạo"
        },
        "placeholder" : {
            "employee-manage" : "Chọn nhân sự quản lý bảng lương",
            "employee-follow" : "Chọn nhân sự theo dõi bang luong",
            "autoGenerated" : "Chọn ngày",
            "valueColumn" : "Chọn giá trị cột",
            "keyColumn" : "Nhập từ khóa",
            "rowValue" : "Chọn ...",
            "typeValue" : "Số hoặc chữ",
            "formatOption" : "Tiền tệ",
            "paycheck" : "Chọn một hình thức"
        },
        "rowValue" : {
            "totalrows" : "Tổng các hàng" ,
            "minvaluerows" : "Giá trị nhỏ nhất của các hàng",
            "maxvaluerows" : "Giá trị lớn nhất của các hàng",
            "valuelastrow" : "Giá trị của hàng cuối cùng",
            "mediumvaluerows" : "Giá trị trung bình của các hàng",
            "formula" : "Công thức"
        },
        "typeValue" :{
            "number" : "Dạng số",
            "word" : "Dạng chữ"
        },
        "paycheck" :{
            "presently" : "Hiện",
            "hide" : "Ẩn"
        },
        "valueSynthetic" : {
            "sumrowvalues" : "Tổng các giá trị hàng",
            "minvaluerow" : "Giá trị nhỏ nhất các hàng",
            "maxvaluerow" : "Giá trị lớn nhất của các hàng",
            "mediumvaluerows" : "Giá trị trung bình của các hàng"
        },
        "message" :{
            "add" : "Thêm cấu hình bảng lương thành công!",
            "edit" : "Sửa cấu hình bảng lương thành công!"
        },
        text1: "Từ khóa cột phải có ít nhất 2 kí tự ,không được chứa ký tự đặc biệt "
    },

}